import { toSlugStringUtil } from 'packages/src'

export default function getSlugExerciseNameUtil (exerciseName) {
  return toSlugStringUtil(exerciseName)
}
